import { HEADER_V4 } from '@photosi/rn-components/headers/header/header.constants';
import { StyleSheet } from 'react-native';
import { Spacing } from 'src/theme-v2/spacing';
import { Stroke } from 'src/theme-v2/stroke';

export const styles = StyleSheet.create({
  headerContainer: {
    paddingHorizontal: Spacing.Cozy,
    paddingVertical: 18,
    alignContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    width: '100%',
    height: HEADER_V4.height.desktop,
    zIndex: 1,
  },
  separator: {
    height: 24,
    borderLeftWidth: 1,
    borderColor: Stroke.StrokeColor.StrokeColorNeutral,
  },
  leftElements: {
    gap: Spacing.Cozy,
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    flexGrow: 4,
    flexShrink: 1,
  },
  leftActions: {
    gap: Spacing.Compact,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  centerElements: {
    gap: Spacing.Relaxed,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    flexGrow: 1,
    flexShrink: 4,
  },
  rightElements: {
    gap: Spacing.Compact,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: 1,
    flexGrow: 4,
    flexShrink: 1,
  },
});
